import { PartnerPermissions } from "../../Component/Permissions/PermissionsInterface.";

export interface ILiquidityPartner {
  liquidityPartnerId: string;
  liquidityPartnerName: string;
  isActive: number;
  createdDate: string; 
  totalPageCount: number;
}

export interface IPayOutPartner {
  payoutPartnerId: string;
  payoutPartnerName: string;
  isActive: number;
  createdDate: string; 
  totalPageCount: number;
}

export interface PartnerState {
  accessToken: string;
  partner: PartnerPermissions;
  liquidityPartnerList: ILiquidityPartner[];
  payOutPartnerList: IPayOutPartner[]
  isOpenAddLiquidityPartnerDialog: boolean;
  isOpenAddPayoutPartnerDialog: boolean;
  isOpenUpdateLiquidityPartnerDialog: boolean;
  isOpenUpdatePayoutPartnerDialog: boolean;
  selectedLiquidityPartner: ILiquidityPartner | null;
  selectedPayoutPartner: IPayOutPartner | null;
  //filter and pagenation
  currentRowsPerPage: number;
  currentPage: number;
  totalRows: number;
  searchText: string;
  filterValue: string;
  selectedKey: String;
  userID: string;
  selectedTab: number;
  paginationReset: boolean;
}

export enum PartnerSelectedTab {
  LIQUIDITY_PARTNER = 0,
  PAYOUT_PARTNER = 1,
}

//Interface for Partner component props
export interface PartnerProps {
}
